var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDRxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.957 19.926h-.027c0-.027 0-.054-.027-.08-2.671-3.996-5.935-7.537-9.847-10.38C33.568-.991 19.27 5.927 10.178 19.31h-.162v19.765h.027c0 .027 0 .054.027.08 2.671 3.996 5.935 7.536 9.847 10.38 14.488 10.458 28.786 3.54 37.878-9.843h.162V19.926Zm-2.914 21.803c-.647.563-1.97 1.717-2.644 2.226-12.275 9.842-23.903 9.226-34.56-2.52a38.152 38.152 0 0 1-2.13-2.549v-8.984h2.13v9.172h5.693V14.187h-5.72v14.08h-2.13v-8.958h-4.964c.728-.67 1.591-1.475 2.212-2.038.647-.563 1.97-1.716 2.644-2.226 12.275-9.842 23.903-9.225 34.56 2.52a38.152 38.152 0 0 1 2.13 2.549v8.18h-2.13v-8.368H44.44v24.887h5.692v-14.91h2.131v9.788h4.964c-.701.67-1.564 1.475-2.185 2.038Z",
    fill: "#4C7C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.189 14.482c-1.025 0-1.862.295-2.51.858-.647.563-1.132 1.421-1.429 2.575-.08.348-.162.697-.243 1.1l1.241.053c.162-.939.486-1.69.971-2.226.46-.537 1.133-.805 1.997-.805.917 0 1.618.456 2.077 1.395.486.939.729 2.199.729 3.862 0 1.153-.108 2.199-.297 3.11a20.287 20.287 0 0 1-.81 2.655 66.015 66.015 0 0 1-1.079 2.575L29.71 41.488v1.394h8.175v-1.555h-6.772l4.83-11.103c.377-.885.755-1.77 1.106-2.682.35-.912.647-1.85.863-2.843.216-.992.35-2.038.35-3.137 0-2.226-.35-3.943-1.025-5.203-.701-1.234-1.726-1.877-3.048-1.877ZM39.423 29.634c.298 0 .54-.24.54-.536a.538.538 0 0 0-.54-.537c-.298 0-.54.24-.54.537 0 .296.242.536.54.536Z",
    fill: "#4C7C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.71 29.634c.298 0 .54-.24.54-.536a.538.538 0 0 0-.54-.537.538.538 0 1 0 0 1.073Z",
    fill: "#4C7C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 0C17.435 0 4 13.221 4 29.5 4 45.806 17.435 59 34 59c16.565 0 30-13.221 30-29.5S50.565 0 34 0Zm0 57.927c-15.971 0-28.894-12.712-28.894-28.4C5.106 13.81 18.03 1.1 34 1.1c15.971 0 28.894 12.711 28.894 28.4 0 15.689-12.95 28.427-28.894 28.427Z",
    fill: "#C0D9F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 68,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_34",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDRxIcon);
export default __webpack_public_path__ + "static/media/DRxIcon.cfa5eda03a77b6b1ade124aff628c7d4.svg";
export { ForwardRef as ReactComponent };